var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { FilterService } from '../filter.service';
import { HostDetailsService } from './host-details.service';
import { Router } from '@angular/router';
import { ToasterService } from 'src/app/toaster.service';
import { Toaster, ToasterType } from 'src/app/shared/types';
import { DataService } from '../data.service';
var HOST_PROFILE_TYPE = 'host';
var HostDetailsComponent = /** @class */ (function () {
    function HostDetailsComponent(route, filterService, toasterService, hostDetailService, router, dataservice) {
        this.route = route;
        this.filterService = filterService;
        this.toasterService = toasterService;
        this.hostDetailService = hostDetailService;
        this.router = router;
        this.dataservice = dataservice;
        this.statInfo = 'empty';
        this.focus = false;
        this.mobile = '';
        this.enteredNumber = false;
        this.lastUsedDevice = '';
        this.toggleableDetails = 'Order Details';
        this.languageMap = {
            en: 'English',
            hi: 'Hindi',
            kn: 'Kannada',
            te: 'Telugu',
            ta: 'Tamil'
        };
        this.hostDetailsToggleableHeaders = [
            'Order Details',
            'Wallet Transactions',
            'Referral Rewards'
        ];
    }
    HostDetailsComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.route.params.subscribe(function (params) {
            _this.mobile = params.mobile || _this.route.snapshot.queryParamMap.get('phone');
            if (!_this.mobile) {
                return;
            }
            _this.getUser();
        });
        this.dataservice.updateSearchCount(this.mobile);
    };
    HostDetailsComponent.prototype.refreshPage = function (pageRefresh) {
        var _this = this;
        this.route.params.subscribe(function (params) {
            _this.mobile = params.mobile || _this.route.snapshot.queryParamMap.get('phone');
            if (!_this.mobile) {
                return;
            }
            _this.getUser();
        });
    };
    HostDetailsComponent.prototype.enteredMobile = function () {
        if (this.mobile.length > 0) {
            this.enteredNumber = true;
        }
        else {
            this.enteredNumber = false;
        }
    };
    HostDetailsComponent.prototype.getUser = function () {
        var _this = this;
        this.headersToggled('Order Details');
        var testMob = new RegExp('[0-9]{10}');
        if (!testMob.test(this.mobile)) {
            this.toasterService.showToaster(new Toaster({
                type: ToasterType.WARNING,
                message: "Please enter a valid 10-digit mobile number",
            }));
        }
        else {
            this.router.navigate(['/host/' + this.mobile]);
            this.generalInfo = null;
            this.accountInfo = null;
            this.hostDetailService.getHostByMobile(this.mobile).subscribe(function (res) {
                _this.toasterService.showToaster(new Toaster({
                    type: ToasterType.SUCCESS,
                    message: "User found",
                }));
                _this.generalDetails = res;
                _this.generalDetails.dataFetched = true;
                _this.accountInfo = res;
                _this.accountInfo.dataFetched = true;
                _this.mobileNumber = _this.mobile;
                var hostProfile = _this.generalDetails.profiles.filter(function (profile) { return profile.type === HOST_PROFILE_TYPE; })[0];
                _this.id = hostProfile ? (hostProfile.id || hostProfile.profileId || hostProfile._id) : undefined;
                _this.mobile = null;
                _this.enteredNumber = false;
            }, function (error) {
                _this.toasterService.showToaster(new Toaster({
                    type: ToasterType.WARNING,
                    message: "Unable to fetch this user. Please check the number again",
                }));
                _this.mobileNumber = _this.mobile;
                _this.generalInfo = { dataFetched: false };
                _this.accountInfo = { dataFetched: false };
            });
        }
    };
    HostDetailsComponent.prototype.headersToggled = function (toggledHeader) {
        this.toggleableDetails = toggledHeader;
    };
    HostDetailsComponent.prototype.changeStatus = function (status) {
        this.mobile = this.mobileNumber;
        this.getUser();
        this.accountInfo = __assign({}, this.accountInfo, { status: status });
    };
    return HostDetailsComponent;
}());
export { HostDetailsComponent };
